import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { ClassroomResponseType, ClassroomsLoaderQuery } from '../../types';
import { getClassrooms } from '../../api';
import DisplayError from '../../../../../components/info/DisplayError';

export const ITEMS_PER_PAGE_DEFAULT = 10;
export const PAGE_DEFAULT = 1;

export interface ClassroomsLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  ClassroomsLoaderQuery,
  ClassroomResponseType,
  AxiosResultDefaultError
>();

export const useClassrooms = useFetch;

export const ClassroomsLoaderConsumer = FetchConsumer;

export function ClassroomsLoader({ children }: ClassroomsLoaderProps) {
  const request = useCallback((query: ClassroomsLoaderQuery) => {
    return getClassrooms({ ...query, page: query.page - 1 });
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{
        items: ITEMS_PER_PAGE_DEFAULT,
        page: PAGE_DEFAULT,
      }}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
